import React from 'react'
import Grid from '@mui/material/Grid'
import { getProfileMemberFields } from '../../../utils/member/baseProfileUtils'

export default function MemberPregnancyFormFields () {
  const memberFields = getProfileMemberFields()
  const renderPregnancyFields = () => {
    return (
      <Grid container spacing={1}>
        <Grid item xs={12} md={6}>{memberFields.conceptionDate.formInput()}</Grid>
        <Grid item xs={12} md={6}>{memberFields.deliveryDate.formInput()}</Grid>
        <Grid item xs={12} md={6}>{memberFields.startWeight.formInput()}</Grid>
      </Grid>
    )
  }

  return renderPregnancyFields()
}
